import { configureStore } from "@reduxjs/toolkit";
import testReducer from "./test";
import meReducer from "./me";

// const rootReducer = combineReducers({ form: formReducer });
// const store = createStore(rootReducer);

export default configureStore({
  reducer: {
    // นำ store ย่อไปผูกไว้กับ store หลัก
    test: testReducer,
    me: meReducer,
  },
});
